export default "__VITE_ASSET__C$SLlY8d__"